module.exports = __webpack_public_path__ + "static/img/transporterlogo.30bdcde.svg";